// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vue-scratchable-wrapper[data-v-df1c6910]{position:relative}.vue-scratchable-wrapper>*[data-v-df1c6910]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}canvas[data-v-df1c6910]{position:absolute;top:0;left:0}", ""]);
// Exports
module.exports = exports;
